"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "ACCESSIBILITY_ACCESS_PERMISSIONS", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.ACCESSIBILITY_ACCESS_PERMISSIONS;
  }
});
Object.defineProperty(exports, "CATALOGING_CATEGORIZATION", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.CATALOGING_CATEGORIZATION;
  }
});
Object.defineProperty(exports, "COLLABORATION", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.COLLABORATION;
  }
});
Object.defineProperty(exports, "COMMENTS", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.COMMENTS;
  }
});
Object.defineProperty(exports, "CONTENT_AGGREGATION", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.CONTENT_AGGREGATION;
  }
});
Object.defineProperty(exports, "CONTENT_MANAGEMENT", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.CONTENT_MANAGEMENT;
  }
});
Object.defineProperty(exports, "CONTENT_TAXONOMY", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.CONTENT_TAXONOMY;
  }
});
Object.defineProperty(exports, "DECISION_TREE", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.DECISION_TREE;
  }
});
Object.defineProperty(exports, "DISCUSSION_BOARDS", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.DISCUSSION_BOARDS;
  }
});
Object.defineProperty(exports, "EXPERTISE_LOCATION", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.EXPERTISE_LOCATION;
  }
});
Object.defineProperty(exports, "FILE_VIEWING", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.FILE_VIEWING;
  }
});
Object.defineProperty(exports, "FULL_TEXT_SEARCH", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.FULL_TEXT_SEARCH;
  }
});
Object.defineProperty(exports, "INTEGRATIONS", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.INTEGRATIONS;
  }
});
Object.defineProperty(exports, "KNOWLEDGE_BASE_MANAGEMENT", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.KNOWLEDGE_BASE_MANAGEMENT;
  }
});
Object.defineProperty(exports, "LINK_SHARING", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.LINK_SHARING;
  }
});
Object.defineProperty(exports, "PUBLIC_PRIVATE", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.PUBLIC_PRIVATE;
  }
});
Object.defineProperty(exports, "Q_A", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.Q_A;
  }
});
Object.defineProperty(exports, "SCALABILITY", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.SCALABILITY;
  }
});
Object.defineProperty(exports, "SEARCHABLE", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.SEARCHABLE;
  }
});
Object.defineProperty(exports, "SELF_SERVICE_PORTAL", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.SELF_SERVICE_PORTAL;
  }
});
Object.defineProperty(exports, "TAGGING", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.TAGGING;
  }
});
Object.defineProperty(exports, "UPLOAD", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.UPLOAD;
  }
});
Object.defineProperty(exports, "VIEWS_DASHBOARDS_REPORTS", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.VIEWS_DASHBOARDS_REPORTS;
  }
});

var _CategoryFeature = require("../CategoryFeature");


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ecosystem-marketplace-core/static-1.1225/js/constants/groupTags/categoryFeatures/KnowledgeBase.js
// module id = 573
// module chunks = 209 210 211 212 213